/* Pagina de produto — ajustes para ficar como a referencia.

   1) Selo "ÉCONOMISEZ": o tema escreve o valor poupado em euros
      ("Économisez €45,00"); na referencia mostra a PERCENTAGEM
      ("ÉCONOMISEZ 59%"), calculada a partir dos dois precos da pagina.

   2) Linha de avaliacao por cima do titulo, ao lado das estrelas.
      O texto e o MESMO que a Lea ja mostra na sua seccao de avaliacoes
      mais abaixo — nao foi inventado nenhum numero. Para o mudar,
      altera RATING_SCORE / RATING_TEXT (e a seccao de avaliacoes).

   3) Ordem: na referencia os tres USPs (La Poste, garantia, pagamento)
      aparecem LOGO A SEGUIR AOS PRECOS, antes do seletor de tamanho.
      Na Lea estavam depois do seletor.

   4) Acordeoes: na referencia a DESCRICAO nao e um acordeao — e texto
      normal, sem titulo "DESCRIPTION", sem seta e sem caixa. Aqui
      marca-se esse acordeao (o que ja vem aberto) com a classe
      "sj-acc-plain", esconde-se o titulo por CSS e mantem-se sempre
      aberto. So os tres acordeoes de garantia e que ficam em caixa. */
(function () {
  var RATING_SCORE = '4.7/5';
  var RATING_TEXT = 'Basé sur +3500 avis';

  function toNumber(txt) {
    if (!txt) return 0;
    var t = txt.replace(/[^0-9.,]/g, '').trim();
    if (t.indexOf(',') > -1 && t.indexOf('.') > -1) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else if (t.indexOf(',') > -1) {
      t = t.replace(',', '.');
    }
    var n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }

  function fixBadge() {
    var wraps = document.querySelectorAll('.product__price__wrap');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var badge = wrap.querySelector('.product__sale span');
      if (!badge) continue;

      var sale = wrap.querySelector('.product__price--sale');
      var strike = wrap.querySelector('.product__price--strike');
      if (!sale || !strike) continue;

      var now = toNumber(sale.textContent);
      var was = toNumber(strike.textContent);
      if (!was || was <= now) continue;

      var pct = Math.round(((was - now) / was) * 100);
      var label = 'ÉCONOMISEZ ' + pct + '%';
      if (badge.textContent.trim() !== label) badge.textContent = label;
    }
  }

  function addRatingText() {
    var blocks = document.querySelectorAll('.sj-stars');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.querySelector('.sj-stars__text')) continue;

      var span = document.createElement('span');
      span.className = 'sj-stars__text';
      span.innerHTML =
        '<strong>' + RATING_SCORE + '</strong>' +
        '<span class="sj-stars__divider">|</span>' +
        RATING_TEXT;
      block.appendChild(span);
    }
  }

  function moveUsps() {
    var wraps = document.querySelectorAll('.form__width');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.dataset.leaUsps === '1') continue;

      var variants = wrap.querySelector('.product__block--lines');
      if (!variants) continue;

      var usp = null;
      var blocks = wrap.querySelectorAll('.product__block.product__custom-code');
      for (var b = 0; b < blocks.length; b++) {
        if (/La Poste/i.test(blocks[b].textContent || '')) { usp = blocks[b]; break; }
      }
      if (!usp) continue;

      wrap.dataset.leaUsps = '1';
      variants.parentNode.insertBefore(usp, variants);
    }
  }

  /* Marca UMA so vez, no arranque, o acordeao que ja vem aberto
     (a descricao). Depois disso o utilizador pode abrir e fechar os
     outros sem que nenhum perca a caixa. */
  var plainDone = false;
  function markPlainAccordion() {
    if (!plainDone) {
      var accs = document.querySelectorAll('.product-accordion');
      if (!accs.length) return;
      plainDone = true;
      for (var i = 0; i < accs.length; i++) {
        var det = accs[i].querySelector('.accordion');
        if (!det) continue;
        var title = (accs[i].textContent || '').trim().toUpperCase();
        if (det.hasAttribute('open') || title.indexOf('DESCRIPTION') === 0) {
          accs[i].classList.add('sj-acc-plain');
        }
      }
    }
    /* O titulo esta escondido, por isso a descricao tem de ficar
       sempre aberta. */
    var plains = document.querySelectorAll('.product-accordion.sj-acc-plain .accordion');
    for (var p = 0; p < plains.length; p++) {
      if (!plains[p].hasAttribute('open')) plains[p].setAttribute('open', '');
    }
  }

  function run() {
    fixBadge();
    addRatingText();
    moveUsps();
    markPlainAccordion();
  }

  function boot() {
    run();
    var tries = 0;
    var timer = setInterval(function () {
      run();
      if (++tries > 20) clearInterval(timer);
    }, 400);

    if (document.body) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(run, 120);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
